// Shared responsive column count for the model / tool card grids on the
// Images, Videos, and Music explore pages. Targets a 3-up layout on desktop
// and steps down on smaller viewports so the model and tool grids stay visually
// in sync.
//
//   ≥993px (MD / LG / XL) → 3 columns
//   768–992px (SM)        → 2 columns
//   ≤767px (XS)           → 1 column
export function getExploreGridColumns({ isXS, isSM } = {}) {
  if (isXS) return 1;
  if (isSM) return 2;
  return 3;
}
